module.exports = __webpack_public_path__ + "static/media/016.3dc58ff9.jpg";